import React from "reactn";

import PropTypes from "prop-types";

//components
import CollectableInner from "./CollectableInner";

// styled components
import ContainerBox from "../../../_common/containers/ContainerBox";
import PageText from "../../../_common/pageText/PageText.styled";

const CollectableContainer = props => {
    const { values, title, desc, products } = props;
    return (
        <ContainerBox>
            <PageText>{title}</PageText>
            <p class="desc">{desc}</p>
            {products.map(data => (
                <CollectableInner values={values} name={data.name} id={data.id}></CollectableInner>
            ))}
        </ContainerBox>
    );
};

CollectableContainer.propTypes = {
    values: PropTypes.array,
    title: PropTypes.string,
    desc: PropTypes.string,
    products: PropTypes.object
};

export default CollectableContainer;
